(function () {
  const mql = window.matchMedia('(max-width: 767px)');

  function initProgress(container) {
    const track = container.querySelector('.product-media-progress__track');
    const bar = container.querySelector('.product-media-progress__bar');
    const mediaCount = parseInt(container.dataset.mediaCount, 10);
    if (!track || !bar || !mediaCount || mediaCount < 2) return;

    const gallery = container.closest('media-gallery');
    if (!gallery) return;
    const slider = gallery.querySelector('.product__media-list');
    if (!slider) return;

    const barWidthPercent = 100 / mediaCount;
    bar.style.width = barWidthPercent + '%';

    function updateBar() {
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      if (maxScroll <= 0) {
        bar.style.transform = 'translateX(0)';
        return;
      }
      const ratio = slider.scrollLeft / maxScroll;
      const maxTranslate = (mediaCount - 1) * 100;
      bar.style.transform = 'translateX(' + ratio * maxTranslate + '%)';
    }

    slider.addEventListener('scroll', updateBar, { passive: true });
    updateBar();
  }

  function setup() {
    if (!mql.matches) return;
    document.querySelectorAll('.product-media-progress').forEach(initProgress);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  mql.addEventListener('change', function (e) {
    if (e.matches) setup();
  });
})();
